import React, { useRef, useEffect } from "react"
import Form from "components/common/Form"
import useLockBodyScroll from "hooks/useLockBodyScroll"

function TrustpilotMicroWidget() {
  const ref = useRef(null)

  useEffect(() => {
    if (typeof window === "undefined") return

    let attempts = 0
    const maxAttempts = 50
    const interval = setInterval(() => {
      attempts++
      if (window.Trustpilot && ref.current) {
        window.Trustpilot.loadFromElement(ref.current, true)
        clearInterval(interval)
      } else if (attempts >= maxAttempts) {
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [])

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id="5419b6a8b0d04a076446a9ad"
      data-businessunit-id="5c80bc13f229920001fc61f4"
      data-style-height="24px"
      data-style-width="100%"
      data-theme="light"
      data-min-review-count="10"
      data-style-alignment="center"
    ></div>
  )
}

function ContactBarForm({ pageId, type, title, showTrustpilot, handleFormSuccess }) {
  useLockBodyScroll()
  return (
    <div className="mt-4">
      <Form
        data={{ type, hideTitle: true }}
        pageId={pageId}
        handleFormSuccess={handleFormSuccess}
        headerContent={
          (title || showTrustpilot) ? (
            <div style={{ textAlign: "center", marginBottom: "1rem" }}>
              {title && <h2 style={{ marginBottom: "0.5rem" }}>{title}</h2>}
              {showTrustpilot && <TrustpilotMicroWidget />}
            </div>
          ) : null
        }
      />
    </div>
  )
}

export default ContactBarForm
